<template>
    <div id="app">
        <router-view v-if="isRouterAlive" />
        <loginBox v-if="$store.state.dialogLogin || (($route.query.w_code || $route.query.w_state) && !islogin)"
            ref="loginBoxs"></loginBox>
        <AiChatComp />
    </div>
</template>

<script>
import loginBox from '@/page/login/loginBox';
import AiChatComp from '@/components/AIChatComp/AiChatComp.vue';

export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload,
            VTheme: this.VTheme,
        }
    },
    data() {
        return {
            isRouterAlive: true,
            islogin: false,
            VTheme: window.document.documentElement.getAttribute("data-theme")
        }
    },
    created() {
        if (window.location.hash.toLowerCase().includes('/login')) {
            this.islogin = true;
            this.$store.commit('setDialogLogin', false);
        } else {
            this.islogin = false;
        }
        if (localStorage.getItem("utype")) {
            this.$store.commit('setUtype', localStorage.getItem("utype"))
        }
        if (localStorage.getItem("utypes")) {
            this.$store.commit('setUtypes', localStorage.getItem("utypes"))
        }
        if (localStorage.getItem("utoken")) {
            this.$store.commit('setUtoken', localStorage.getItem("utoken"))
        }
        if (localStorage.getItem("headimgurl")) {
            this.$store.commit('setHeadimgurl', localStorage.getItem("headimgurl"))
        }

    },
    methods: {
    },
    components: {
        loginBox, AiChatComp
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            })
        }
    },
    watch: {
        '$route'(to, from) { //监听路由是否变化
            // toLowerCase()方法把字母转换成小写
            // includes() 判断路由中是否包含'/login'包含返回true
            if (to.path.toLowerCase().includes('/login')) {
                this.islogin = true;
                this.$store.commit('setDialogLogin', false);
            } else {
                this.islogin = false;
                // this.islogin = true
            }

            let path = to.path.toLowerCase()
            const words = [
                "/index/home", "/index/moreList", "/index/organizationList", "/index/exchangeList",
                "/index/courseDetail", "/index/classDetail/", "/index/classManagement", "/index/classManagement"
            ];
            /*   const hasMatch = words.some(word =>
                   path.toLowerCase().includes(word.toLowerCase())
               );
               if(hasMatch){
                   document.getElementById("div_company_mini").style.display = "block"
               }else{
                   document.getElementById("div_company_mini").style.display = "none"
               }*/

        },
    }

}
</script>

<style lang="scss">
@import 'assets/css/theme/_handle.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue